import { call, put, takeLatest, all } from 'redux-saga/effects'
import readyTypes from './readyTypes'
import * as readyActions from './readyActions'
import ReadyToInvoice from '../../services/OrdersService/ReadyToInvoice'

export function * getReady ({ payload }) {
  try {
    const { offset } = payload
    if (offset === 0) {
      yield put(readyActions.clearReady())
    }
    const { data, results } = yield call(ReadyToInvoice.getReady, payload)
    yield put(readyActions.getReadySuccess({ data, results }))
  } catch (error) {
    yield put(readyActions.getReadyFailure(error.message))
  }
}

export function * onGetReady () {
  yield takeLatest(readyTypes.GET_READY, getReady)
}

export function * readyOrderSaga () {
  yield all([
    call(onGetReady)
  ])
}
